<template>
  <div class="chat-page">
    <div class="chat-container">
      <!-- 左侧会话列表 -->
      <div class="chat-left">
        <ChatSessionList
          ref="sessionList"
          :currentSessionId="currentSession ? currentSession.session_id : null"
          @select-session="handleSelectSession"
        />
      </div>

      <!-- 右侧聊天窗口 -->
      <div class="chat-right">
        <ChatWindow
          :currentSession="currentSession"
          @message-sent="handleMessageSent"
          @messages-read="handleMessagesRead"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChatSessionList from '@/components/chat/ChatSessionList.vue'
import ChatWindow from '@/components/chat/ChatWindow.vue'

import { getChatSessionDetail } from '@/api/chat'

export default {
  name: 'ChatPage',
  components: {
    ChatSessionList,
    ChatWindow
  },
  data () {
    return {
      currentSession: null
    }
  },
  mounted () {
    // 检查 URL 参数中是否有 session_id，如果有则自动打开该会话
    const sessionId = this.$route.query.session_id
    if (sessionId) {
      this.openSessionById(parseInt(sessionId))
    }
  },
  methods: {
    /**
     * 选择会话
     */
    handleSelectSession (session) {
      this.currentSession = session
    },

    /**
     * 通过会话ID打开会话
     */
    async openSessionById (sessionId) {
      try {
        const res = await getChatSessionDetail(sessionId)
        if (res.data.code === 0) {
          this.currentSession = res.data.data.session
        } else {
          this.$Message.error(res.data.msg || '获取会话详情失败')
        }
      } catch (error) {
        console.error('打开会话失败:', error)
        this.$Message.error('打开会话失败')
      }
    },

    /**
     * 消息发送成功后的处理
     */
    handleMessageSent ({ sessionId, message }) {
      // 更新会话列表中该会话的最后消息和时间
      if (this.$refs.sessionList) {
        this.$refs.sessionList.updateSession(sessionId, {
          last_message: message,
          last_message_time: message.created_at
        })
      }
    },

    /**
     * 消息标记已读后的处理
     */
    handleMessagesRead (sessionId) {
      // 更新会话列表中该会话的未读数
      if (this.$refs.sessionList) {
        this.$refs.sessionList.updateSession(sessionId, {
          unread_count: 0
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chat-page {
  height: calc(100vh - 60px); // 减去顶部导航栏高度
  background: #f5f5f5;
  padding: 20px;

  .chat-container {
    height: 100%;
    display: flex;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .chat-left {
      width: 320px;
      flex-shrink: 0;
      height: 100%;
    }

    .chat-right {
      flex: 1;
      height: 100%;
      overflow: hidden;
    }
  }
}

// 响应式布局
@media screen and (max-width: 768px) {
  .chat-page {
    padding: 0;
    height: 100vh;

    .chat-container {
      border-radius: 0;

      .chat-left {
        width: 100%;
        display: none;

        &.mobile-show {
          display: block;
        }
      }

      .chat-right {
        width: 100%;
        display: none;

        &.mobile-show {
          display: block;
        }
      }
    }
  }
}
</style>
